import { ApiService, toBodyModel, toModel } from '~/shared/api'
import {
  EmployerFilters,
  EmployerListResult,
  EmployerModel,
} from '~/models/employer'
import { API_PREFIX } from '~/shared/const/request-services'
import { unwrapDataOrBody } from '~/shared/utils/response'

type QueryParams = Record<string, string | number>

const DEFAULT_LIST_PARAMS = {
  'page[size]': 8,
  'filter[vacancies_count]': 'gt|0|int',
  include: 'regions',
} as const

export class EmployerService extends ApiService {
  readonly urls = {
    list: `${API_PREFIX}/employers/query`,
    filters: `${API_PREFIX}/employers/filters`,
    bySlug: (slug: string | number) => `${API_PREFIX}/employers/${slug}`,
  }

  getList(params: QueryParams = {}): Promise<EmployerListResult> {
    return this.http
      .request({
        url: this.urls.list,
        params: { ...DEFAULT_LIST_PARAMS, ...params },
      })
      .then(toBodyModel(EmployerListResult))
  }

  async getFilters(params: QueryParams = {}): Promise<EmployerFilters> {
    const res = await this.http.request({
      url: this.urls.filters,
      params,
    })
    return new EmployerFilters({ data: unwrapDataOrBody(res.data) ?? [] })
  }

  getBySlug(slug: string | number, params: QueryParams = {}): Promise<EmployerModel> {
    return this.http
      .request({ url: this.urls.bySlug(slug), params })
      .then(toModel(EmployerModel))
  }
}
